import { formatCurrency } from 'common/FormatUtilities';
import { BoldText, Line } from './styles';

interface ITotalLine {
  dataCy?: string;
  totalText?: string;
  total: number;
}

export const TotalLine = ({ dataCy = 'total-value', totalText = 'Total', total }: ITotalLine) => (
  <Line>
    <BoldText>{totalText}</BoldText>
    <BoldText data-cy={dataCy}>{formatCurrency(total)}</BoldText>
  </Line>
);
